'use strict';

const PricePublisherMixin = require('od-modules/mixins/price_publisher.mixin');
const isRenewalAtFirstBooking = require('od-modules/helpers/membership/is_renewal_at_first_booking');
const getSubscriptionOffer = require('od-modules/helpers/membership/get_subscription_offer');
const cancelSubscription = require('od-modules/helpers/membership/cancel_subscription');
const usersHelper = require('od-modules/helpers/user.js');

const REMOVE_ACTION = 'remove';
const SSO_REMEMBER_ME_COOKIE = 'sso_remember_me';
const COOKIE_SEPARATOR = ';';

module.exports = Backbone.Model.extend(PricePublisherMixin.extend({
    defaults: {
        type: 'MEMBERSHIP_SUBSCRIPTION',
        operation: 'RENEWAL_AT_FIRST_BOOKING',
        conceptKey: 'membershipsubscription',
        conceptLabel: '',
        isRenewalAtFirstBooking: null,
        getSubscriptionOffer: null,
        isCancel: false,
        allPrice: 0,
        allPriceFromBackend: 0,
        onePrice: 0,
        onePriceFromBackend: 0,
        member: {},
        quantity: null,
        isUserLoggedIn: false,
        isPriceWithoutDiscountSelected: false,
        updateMembershipResponse: null,
        renewalGenericError: null,
    },
    currentAction: null,
    url() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(this.currentAction.getUrl());
    },
    initialize() {
        this.bindEvents();
    },
    bindEvents() {
        this.on('change:updateMembershipResponse', this.onUpdateMembershipResponse.bind(this));
    },
    getDataRequestSettings(success) {
        return {
            dataType: 'json',
            contentType: 'application/json',
            type: this.currentAction.getMethod(),
            success: success ? success.bind(this) : () => {},
        };
    },
    isRenewalAtFirstBooking() {
        this.currentAction = isRenewalAtFirstBooking;
        this.fetch(this.getDataRequestSettings(this.getRenewalFromResponse));
    },
    buildPriceFromOffer(offer) {
        return {
            onePriceFromBackend: +offer.price,
            allPriceFromBackend: +offer.price,
            formattedPrice: Odigeo.Utils.formatCurrency(offer.price, Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 2})),
        };
    },
    getSubscriptionOffer() {
        const callback = Odigeo._.flowRight(
            this.addProduct,
            this.set.bind(this),
            this.buildPriceFromOffer,
            this.getOfferFromResponse,
        );
        this.currentAction = getSubscriptionOffer;
        this.fetch(this.getDataRequestSettings(callback));
    },
    getOfferFromResponse($widget, response) {
        var offer = Odigeo._.get(response, 'membershipSubscriptionOfferDTO');
        return Odigeo._.isObject(offer) && Odigeo._.isEmpty(response.errors) ? offer : {price: 0};
    },
    getRenewalFromResponse(model, isRenewal) {
        this.set('isRenewalAtFirstBooking', isRenewal);
        Odigeo.Session.set('isRenewalAtFirstBooking', isRenewal);
        return isRenewal;
    },
    getRequestData() {
        return {
            quantity: this.get('quantity'),
            operation: this.get('operation'),
        };
    },
    isRemoveAction(action) {
        return action === REMOVE_ACTION;
    },
    addProduct() {
        this.updateProduct('add');
    },
    onUpdateMembershipResponse() {
        const updateMembershipResponse = this.get('updateMembershipResponse');
        if (updateMembershipResponse !== null && updateMembershipResponse.response === 'true') {
            return this.editCookie();
        }
        this.set('renewalGenericError', true);
    },
    editCookie() {
        if (Odigeo.Utils.readCookie(SSO_REMEMBER_ME_COOKIE)) {
            let ssoRememberMeCookie = decodeURIComponent(Odigeo.Utils.readCookie(SSO_REMEMBER_ME_COOKIE)).split(COOKIE_SEPARATOR);
            if (ssoRememberMeCookie.length >= 3) {
                ssoRememberMeCookie[2] = 'false';
                Odigeo.Utils.createCookie(SSO_REMEMBER_ME_COOKIE, encodeURIComponent(ssoRememberMeCookie.join(COOKIE_SEPARATOR)));
                usersHelper.membershipRefreshPage('unsubscribed');
            }
        }
    },
    deactivateMembership() {
        this.currentAction = cancelSubscription;
        this.fetch(this.getDataRequestSettings());
    },

    updateProduct(action) {
        this.set({
            quantity: this.isRemoveAction(action) ? 0 : 1,
            allPrice: this.isRemoveAction(action) ? 0 : this.get('allPriceFromBackend'),
            onePrice: this.isRemoveAction(action) ? 0 : this.get('onePriceFromBackend'),
            isPriceWithoutDiscountSelected: this.isRemoveAction(action),
        });
    },
    onQuantityChange() {
        this.addItemToPricemanagerCollection(this.attributes);
    },
    removeAndAddProduct() {
        this.set({quantity: 0}, {silent: true});
        this.addProduct();
    },
}));
